<template>
  <div class="comfirm">
    <div></div>
    <title-section
      title="Hemos recibido tu solicitud y nos pondremos en contacto contigo lo antes posible"
      subtitle="Gracias por confiar en nosotros, estaremos dispuestos para ayudarte."
    ></title-section>
    <div class="btn-back">
    <a href="/" class="btn btn-primary mt-12 fixed-button items-center"><span>Volver a la home</span></a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.comfirm {
  @media (max-width: 992px) {
    height: 65vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .fixed-button {
    @media (max-width: 992px) {
      width: 100% !important;
      height: 50px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.btn-back {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
 
}
.btn {
  margin-left: auto;
  margin-right: auto;
  border-radius: 24px;
   width: 140px!important;

}
</style>